import React from 'react'
import { Navigate, useLocation } from "react-router";
import { getCustomer } from "./queries/global"
import LoadingIndicator from './components/loading-indicator';

// For routes that are protected this componenet checks whether the user is logged in 
// and if they aren't it sends them to the login page and passes the route to return to.
// The redirection logic is in the Login component.
export const ProtectedRoute = ({ children }) => {
    const { data: customer, isPending, isFetching } = getCustomer();
    const location = useLocation();

    if (isPending || isFetching) return <LoadingIndicator type="page" />
    return customer ? children : <Navigate to="/login" replace state={{ from: location }} />;
};
